<nav class="subnav">
  <div class="prev">
    <a [routerLink]="['/programme', 'achievements']"
      ><span class="icon-wrap"
        ><fa-icon [icon]="['fas', 'circle-arrow-left']"></fa-icon></span
    ></a>
  </div>
  <h2>About iPrepWell</h2>
  <div class="next"></div>
</nav>
<div class="container container-inner">
  <div class="row">
    <div class="col-12 col-md-6">
      <h4 class="text-center mt-4 mb-2">About the programme</h4>
      <div class="card bg-light">
        <div class="card-body">
          <ul class="link-list">
            <li>
              <a [routerLink]="['/welcome']">
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">Welcome to iPrepWell</span>
                <span class="icon-wrap more-link text-primary"
                  ><fa-icon [icon]="['fas', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/live-well', 8]">
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">Live Well Cycle</span>
                <span class="icon-wrap more-link text-primary"
                  ><fa-icon [icon]="['fas', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/more', 'about']">
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">About the programme</span>
                <span class="icon-wrap more-link text-primary"
                  ><fa-icon [icon]="['fas', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
